import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import bindMethods from 'auto-bind';

import { createHyperCubeDefForField, getQlikApp } from '../../../utils/qlik';
import { getQlikAppId } from '../../../state/selectors/getQlikAppId';
import { addSeasonsData, resetSeasonsData } from '../../../state/seasons';
import { addSeason, removeSeason } from '../../../state/teamSeasonGameSelection';
import {
  selectSeason,
  clearGamesField,
  clearSeasonField,
  clearTeamField,
} from '../../../utils/qlikSelectValue';
import { FOOTBALL_SEASON } from '../../../constants/fields';
import FilterItemPicker from './FilterItemPicker';
import { generateSeasonOptions } from '../../../utils/generateTeamSeasonOptions';
import { getSeasonValue } from '../../../state/selectors/getFilterValue';
import { reapplyDefaultSelections } from '../../../utils/defaultSelections';

class SeasonFilter extends PureComponent {
  constructor(props) {
    super(props);
    bindMethods(this);

    this.hyperCubeDef = createHyperCubeDefForField(FOOTBALL_SEASON);
    this.app = null;
  }

  async componentDidMount() {
    const { qlikAppId } = this.props;

    this.app = await getQlikApp(qlikAppId);
  }

  componentDidUpdate(prevProps) {
    const { qlikAppId, teamSeasonGameSelection, resetSeasonsData } = this.props;
    const previousTeamSelection = prevProps.teamSeasonGameSelection.team;
    const currentTeamSelection = teamSeasonGameSelection.team;

    if (qlikAppId) {
      if (previousTeamSelection !== currentTeamSelection && currentTeamSelection.length > 0) {
        this.getSeasonData();
      }
      if (previousTeamSelection !== currentTeamSelection && !currentTeamSelection) {
        resetSeasonsData();
        getQlikApp(qlikAppId).then((app) => {
          clearTeamField(app);
          clearSeasonField(app);
          clearGamesField(app);

          const { defaultSelections } = this.props;
          reapplyDefaultSelections(app, defaultSelections);
        });
      }
    }
  }

  async getSeasonData() {
    if (!this.app) {
      const { qlikAppId } = this.props;
      this.app = await getQlikApp(qlikAppId);
    }

    const { addSeasonsData } = this.props;

    clearSeasonField(this.app);
    clearGamesField(this.app);

    this.app.createCube(this.hyperCubeDef).then((results) => {
      const seasonList = results.layout.qHyperCube.qDataPages[0].qMatrix.map(x => x[0].qText);
      addSeasonsData(seasonList);
    });
  }

  generateOptions() {
    const {
      seasons,
      teamSeasonGameSelection: { team },
    } = this.props;
    const options = generateSeasonOptions(team, seasons.seasons);
    return options;
  }

  handleChange(value) {
    const { addSeason, removeSeason, qlikAppId } = this.props;

    if (value) {
      addSeason(value.value);
      getQlikApp(qlikAppId).then((app) => {
        selectSeason(app, [value.value]);
      });
    } else {
      removeSeason();
      getQlikApp(qlikAppId).then((app) => {
        clearSeasonField(app);
        clearGamesField(app);
      });
    }
  }

  render() {
    const { seasons, getSeasonValue } = this.props;

    if (seasons.isLoaded) {
      return (
        <FilterItemPicker
          id="Sidebar.Filters.Season"
          options={this.generateOptions()}
          value={getSeasonValue}
          onChange={this.handleChange}
        />
      );
    }

    return null;
  }
}

SeasonFilter.propTypes = {
  qlikAppId: PropTypes.string.isRequired, // supplied from Redux
  teamSeasonGameSelection: PropTypes.object.isRequired, // supplied from Redux
  addSeasonsData: PropTypes.func.isRequired, // supplied from Redux
  resetSeasonsData: PropTypes.func.isRequired, // supplied from Redux
  getSeasonValue: PropTypes.oneOfType([PropTypes.string, PropTypes.object]).isRequired,
  seasons: PropTypes.object.isRequired, // supplied from Redux
  addSeason: PropTypes.func.isRequired, // supplied from Redux
  removeSeason: PropTypes.func.isRequired, // supplied from Redux
  defaultSelections: PropTypes.object.isRequired, // supplied from Redux
};

const mapStateToProps = state => ({
  qlikAppId: getQlikAppId(state),
  getSeasonValue: getSeasonValue(state),
  teamSeasonGameSelection: state.teamSeasonGameSelection,
  seasons: state.seasons,
  defaultSelections: state.defaultSelections,
});

const mapDispatchToProps = {
  addSeasonsData,
  resetSeasonsData,
  addSeason,
  removeSeason,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(SeasonFilter);
